import React, { useEffect, useState } from "react";
import { Button, Progress, Card, Row, Col } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import CoinImage from "../../assets/images/header-coin-icon.svg";
import SendIconImage from "../../assets/images/send-image-icon.svg";
import WithdrawImage from "../../assets/images/withdrawwl-image.svg";
import ArrowUpRed from "../../assets/images/red-up-icon.svg";
import ArrowUpGreen from "../../assets/images/green-down-icon.svg";
import Main from "../../components/layout/Main";
import { useNavigate } from "react-router";
import { useWallet } from "../../context/WalletContext";
import moment from "moment";
import { isScrollAtBottom, toCapitalize } from "../../helper/functions";
import { DEFAULT_LIMIT, DEFAULT_PAGE } from "../../helper/functions";

const WalletPage = () => {
  const Navigate = useNavigate();
  const [fullWidth, setFullWidth] = useState(false);
  const [walletSummary, setWalletSummary] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [page, setPage] = useState(DEFAULT_PAGE);
  const [hasMore, setHasMore] = useState(true);
  const limit = DEFAULT_LIMIT;
  // -------------- call api to get wallet summary -----------
  const { loadWalletSummary, loadTransactions } = useWallet();

  // ------------ Handlers ------------
  const fetchWalletSummary = async (reset = false) => {
    const response = await loadWalletSummary();
    const transactions = await loadTransactions({ page, limit });
    setWalletSummary(response?.data);
    if (reset) {
      setTransactions(transactions?.data?.transactions);
    } else {
      setTransactions((prev) => [...prev, ...transactions?.data?.transactions]);
    }
  };

  const handleScroll = (e) => {
    if (isScrollAtBottom(e) && hasMore) {
      setPage((prev) => prev + 1);
    }
  };

  useEffect(() => {
    fetchWalletSummary();
  }, []);

  useEffect(() => {
    if (page > 1) {
      fetchWalletSummary();
    }
  }, [page]);

  useEffect(() => {
    setPage(DEFAULT_PAGE);
    setHasMore(true);
    fetchWalletSummary(true);
  }, []);

  return (
    <Main>
      <div className="wallet-page">
        <div className="orange-header">My Wallet</div>

        <Row gutter={[16, 16]}>
          <Col span={24} md={16}>
            <Card className="wallet-balance-card">
              <div className="wallet-balance-info">
                <div className="wallet-buy-now-button">
                  <h1 className="wallet-balance-value">
                    <img
                      src={CoinImage}
                      alt="coin"
                      className="wallet-coin-img"
                    />
                    {Number(walletSummary?.wallet?.total_balance).toFixed(2)}{" "}
                    TKN
                  </h1>
                  <Button
                    className="Fill-button"
                    icon={<PlusOutlined />}
                    onClick={() => Navigate("/wallet/buy-token")}
                  >
                    Buy Now
                  </Button>
                </div>
              </div>
              <div className="wallet-actions">
                <Button
                  className="border-button"
                  onClick={() => Navigate("/wallet/send-token")}
                >
                  {" "}
                  <img src={SendIconImage} /> Send
                </Button>
                <Button
                  className="border-button"
                  onClick={() => Navigate("/wallet/withdraw-token")}
                >
                  {" "}
                  <img src={WithdrawImage} /> Withdraw
                </Button>
              </div>
            </Card>

            <div className="wallet-history-header">
              <p>Transaction History</p>
              <span
                onClick={() => setFullWidth((prev) => !prev)}
                style={{ cursor: "pointer" }}
              >
                View all
              </span>
            </div>

            <div
              className="wallet-history-list"
              style={
                fullWidth
                  ? { height: "700px", overflowY: "scroll" }
                  : { height: "370px", overflowY: "hidden" }
              }
              onScroll={handleScroll}
            >
              {transactions?.map((item, index) => (
                <div key={index} className="wallet-history-item">
                  <div className="wallet-history-left">
                    <div className="wallet-history-arrow-image">
                      {item.type === "send" ? (
                        <img src={ArrowUpRed} />
                      ) : (
                        <img src={ArrowUpGreen} />
                      )}
                    </div>
                    <div>
                      <p style={{ textAlign: "left" }}>
                        {toCapitalize(item.type)}{" "}
                        {item.type === "send" ? "to" : "from"}{" "}
                        <span className="wallet-history-user">
                          {item.type === "send"
                            ? item.to
                              ? toCapitalize(item.to)
                              : item.id
                            : item.from
                            ? toCapitalize(item.from)
                            : item.id}
                        </span>
                      </p>
                      <p className="wallet-history-date">
                        {moment(item.date).format("MMM DD, YYYY")}
                      </p>
                    </div>
                  </div>
                  <div className="wallet-history-right">
                    <p className={`wallet-history-amount ${item.type}`}>
                      {item.amount}
                    </p>
                    <p className="wallet-history-status">{item.status}</p>
                  </div>
                </div>
              ))}
            </div>
          </Col>
          <Col span={24} md={8}>
            <div className="wallet-limits-card">
              <div className="wallet-limits-card-inner">
                <div className="header-wallet-proo">
                  <p>Monthly</p>
                  <h5>{walletSummary?.limits?.monthly?.used_percentage}%</h5>
                </div>
                <Progress
                  percent={walletSummary?.limits?.monthly?.used_percentage}
                  showInfo={false}
                  className="wallet-progress"
                />
                <p className="wallet-progress-label">
                  {walletSummary?.limits?.monthly?.remaining} TKN remaining this
                  month
                </p>
              </div>
              <div className="wallet-limits-card-inner">
                <div className="mb-2">
                  <div className="header-wallet-proo">
                    <p>Withdrawal Limit</p>
                    <h5>
                      {walletSummary?.limits?.withdrawal?.used_percentage}%
                    </h5>
                  </div>

                  <Progress
                    percent={45}
                    showInfo={false}
                    className="wallet-progress"
                  />
                  <p className="wallet-progress-label">
                    {walletSummary?.limits?.withdrawal?.remaining} TKN remaining
                    this month
                  </p>
                </div>

                <div className="header-wallet-proo">
                  <p>Sending Friends Limit</p>
                  <h5>
                    {walletSummary?.limits?.sending_to_friends?.used_percentage}
                    %
                  </h5>
                </div>
                <Progress
                  percent={25}
                  showInfo={false}
                  className="wallet-progress"
                />
                <p className="wallet-progress-label">
                  {walletSummary?.limits?.sending_to_friends?.remaining} TKN
                  remaining for gifts
                </p>

                <div className="header-wallet-proo">
                  <p>Sending Streamers Limit</p>
                  <h5>
                    {
                      walletSummary?.limits?.sending_to_streamers
                        ?.used_percentage
                    }
                    %
                  </h5>
                </div>
                <Progress
                  percent={25}
                  showInfo={false}
                  className="wallet-progress"
                />
                <p className="wallet-progress-label">
                  {walletSummary?.limits?.sending_to_streamers?.remaining} TKN
                  remaining for gifts
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </Main>
  );
};

export default WalletPage;
